export enum Satisfaction {
    DISLIKED = 'Satisfait',
    NEUTRAL = 'Neutre',
    LOVED = 'Très satisfait'
}
